import React from "react";
import TypingPanel from "./TypingPanel";

/**
 * TypingView — the in-app overlay wrapper around TypingPanel (the working
 * surface shared with the public /typing page), following the same
 * SarfTool/SarfPanel split. A full-screen overlay rather than a sidebar
 * section because a drill wants the full width for the keyboard diagram.
 * Escape handling lives in TypingPanel.
 */
export default function TypingView({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[3px] p-4"
      onClick={onClose}
    >
      <TypingPanel onClose={onClose} context="overlay" />
    </div>
  );
}
